import React, { Component } from 'react';
import Layout from "../Layout";

import { Button, Input, Checkbox } from "~/js/partials";
import { isInitialValid } from "~/js/utils";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { formsService } from '~/js/_services';
import Turnstile from "react-turnstile";

const vehicle = window.current_vehicle ?? null;
const dealer = window.current_dealer ?? null;

class FormVirtualAppointmentSpecific extends Component {
    state = {
        turnstileToken : "",
    };
    handleSubmit = (fields, { setStatus, setSubmitting }) => {
        const { showSuccessPopup } = this.props;
        setStatus();
        let turnstileData = {
            response: this.state.turnstileToken,
        }

        //check Turnstile Backend Verification
        formsService.turnstileVerification(turnstileData).then((response) => {
            if(response.data.success){
        let data = {
            name: 'Virtual Appointment Specific Vehicle',
            fields: JSON.parse(JSON.stringify(fields))
        };

        data.vehicle = vehicle ? `${vehicle['@LISTING_STOCK_NO']} (${vehicle['@LISTING_TITLE']})` : null;
        data.dealer = dealer ? `${dealer.data.autoplay.dealer} (${dealer.post_title})` : null;
        data.fields.stockNumber = vehicle ? `${vehicle['@LISTING_STOCK_NO']}` : null;
        if (dealer) {
            data.fields.formDealerID = window.current_dealer['ID'];
        }

        formsService.bookVirtualAppointmentSpecific(data).then(
            success => {
                const title = "Your submission is successful"
                const text = "We will contact you about your booking."
                showSuccessPopup({ title, text });
                setSubmitting(false);
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'FormSubmit',
                    'formType': this.props.type,
                    'formBrand': vehicle ? vehicle['@LISTING_MAKE'] : null,
                    'formModel': vehicle ? vehicle['@LISTING_MODEL'] : null,
                    'formRegion': null,
                    'formDealership': data.dealer ? data.dealer : null,
                    'formKm0': vehicle ? vehicle['@LISTING_ODOMETER'] : null,
                    'formVehicleRegistration': vehicle ? vehicle['@LISTING_STOCK_NO'] : null
                });
            },
            error => {
                setSubmitting(false);
                setStatus(error.message);
            }
        );
            }else{
                setSubmitting(false);
                setStatus("Error with Turnstile Verification");
            }
        });
    };

    renderForm = (props) => {
        const { isValid, isSubmitting, status } = props;

        return (
            <Form className="popup-form__form">
                <div className="popup-form__group">
                    <div className="popup-form__label">Personal details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`firstName`}
                                placeholder={`First Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                        <div className="popup-form__col">
                            <Input
                                name={`lastName`}
                                placeholder={`Last Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`phone`}
                                placeholder={`Phone`}
                                modifiers={['form']}
                                form={props}
                                type="tel"
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`email`}
                                placeholder={`Email (optional)`}
                                modifiers={['form']}
                                form={props}
                                type="email"
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Checkbox
                                label={{ text: 'FaceTime (iPhone)'}}
                                name={`facetime`}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Checkbox
                                label={{ text: 'Facebook Messenger'}}
                                name={`messenger`}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Checkbox
                                label={{ text: 'Other'}}
                                name={`other`}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className={`popup-form__row pb-3 ${props.values.other ? '' : 'popup-form__col--hidden'}`}>
                        <div className="popup-form__col">
                            <Input
                                name={`otherText`}
                                placeholder={``}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>
                </div>

                {status &&
                    <div className={'popup-form__alert pb-3'}>{status}</div>
                }
                <Turnstile
                    sitekey={process.env.TURNSTILE_SITE_KEY}
                    onVerify={(token) => {
                        this.setState({turnstileToken : token});
                    }}
                    theme={'light'}
                />
                <div className="popup-form__submit">
                    <Button
                        extraClass={`form-test-drive-${vehicle['@LISTING_SEQ']}`}
                        title={`Submit details`}
                        modifiers={['solid', 'medium']}
                        chevron={true}
                        type="submit"
                        disabled={!isValid || !this.state.turnstileToken}
                        loading={isSubmitting}
                    />
                </div>
            </Form>
        );
    }

    render() {
        const { ...rest } = this.props;
        const title = 'Book a virtual appointment';
        const text = 'Fill in your details below to schedule a virtual viewing. A dealership representative will get in touch to arrange appointment details.';

        const initialValues = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            facetime: false,
            messenger: false,
            zapierUrl: window.location.href,
            other: false,
            otherText: '',
        };

        const validationSchema = Yup.object().shape({
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            email: Yup.string().email('Invalid email'),
            phone: Yup.string().required('Required'),
        });

        return (
            <Layout
                title={title}
                text={text}
                vehicle={vehicle}
                dealer={dealer}
                dealerSpecific={dealer}
                {...rest}
            >
                <Formik
                    isInitialValid={isInitialValid}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                    children={this.renderForm}
                />
            </Layout>
        );
    }
}

export default FormVirtualAppointmentSpecific;
